import { Button } from '@mui/material';
import * as React from 'react';
import MyDialog from '../custom-components/dialog';
import MyTable from '../custom-components/table'

import { db } from '../firebase';

export default function UsersCurrent() {
    let [playerPool, setplayerPool] = React.useState([])
    const columns = ['Name', 'Email', 'Uid', 'Remove']
    const [openDialog, setopenDialog] = React.useState(false)
    const [selectedPlayer, setselectedPlayer] = React.useState(null)
    const [selectedPlayerName, setselectedPlayerName] = React.useState(null)

    function handleRemove(player) {
        console.log(player)
        setselectedPlayer(player)
        setselectedPlayerName(player.Name)
        setopenDialog(true)
    }

    async function confirmDisableUser() {
        console.log('Confirm delete', selectedPlayer)
        let playerData
        await db.collection('appusers').doc(selectedPlayer.Uid)
            .get()
            .then((doc) => {
                playerData = doc.data()
            })
            .catch((e) => {
                console.log(e)
            })

        await db.collection('appusers_disabled').doc(selectedPlayer.Uid)
            .set(playerData)
            .then(() => {
                console.log('user added to disabled')
            })
            .catch((e) => {
                console.log(e)
            })

        db.collection('appusers').doc(selectedPlayer.Uid)
            .delete()
            .then(() => {
                getPlayerPool()
                setopenDialog(false)
            })
            .catch((e) => {
                console.log(e)
                setopenDialog(false)
            })
    }

    function getPlayerPool() {
        db.collection("appusers").get()
            .then((querySnapShot) => {
                var newplayerPool = []
                querySnapShot.forEach((doc) => {
                    const data = doc.data()
                    const player = {
                        Name: data.displayName,
                        Email: data.email,
                        Uid: data.uid,
                        Remove: (<Button variant='outlined' color='error' onClick={() => { handleRemove(player) }} >Remove</Button>)
                    }

                    newplayerPool.push(player)
                })
                setplayerPool(newplayerPool)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    React.useEffect(() => {
        getPlayerPool()
    }, [])

    return (
        <div className='center margin'>
            <MyTable columns={columns} rows={playerPool}></MyTable>
            <MyDialog dialogTitle={'Delete Admin'} dialogContent={'Do you want to disable user ' + selectedPlayerName + ' from users?\nUser can be reactivated and no record will be lost.'} open={openDialog} closeDialog={() => { setopenDialog(false) }} onConfirm={confirmDisableUser} ></MyDialog>
        </div>

    );
}

